import React from 'react'

const TermsContext = React.createContext()
export default TermsContext
